<template>
  <AdminConfirmModal
    v-model="getAcceptExtensionModal"
    :message="$t('Tariffs.sure_want_continue')"
    :confirm-text="$t('Default.accept')"
    @confirm="acceptExtension"
  />
</template>
<script>
import { computed, ref } from "@vue/composition-api";
import { GlobalMutationTypes } from "@/store/modules/global/types";
import { DispatchTypes } from "@/store/modules/admin/tariffs/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: [],
  setup(props, { root }) {
    const store = useStore();

    const { userInfo } = globalVariables();

    const getAcceptExtensionModal = shortComputed(
      {
        storeType: "global",
        key: "getAcceptExtensionModal",
      },
      GlobalMutationTypes.setAcceptExtensionModal
    );

    const payload = ref({
      status: 2,
    });

    const acceptExtension = () => {
      store
        .dispatch(DispatchTypes.changeTariffApplication, {
          id: currentTariffApplication.value.id,
          payload: payload.value,
        })
        .then(() => {
          store.commit(GlobalMutationTypes.setAcceptExtensionModal, false);
          store.dispatch(DispatchTypes.getTariffsApplication, "?status=" + 1);
          root.$router.push("/admin/extension");
        });
    };

    const currentTariffApplication = computed(
      () => store.state.tariffs.tariffApplication
    );
    return {
      store,
      getAcceptExtensionModal,
      acceptExtension,
      userInfo,
      payload,
    };
  },
};
</script>
